(() => {
  const selector = '[data-hgb-category-shop]';

  const setup = (root) => {
    if (!root || root.dataset.hgbCategoryReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-hgb-category-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-hgb-category-panel]'));

    if (!tabs.length || !panels.length) return;

    root.dataset.hgbCategoryReady = 'true';

    const activateTab = (nextTab, focus = false) => {
      const targetId = nextTab.dataset.target;

      tabs.forEach((tab) => {
        const isActive = tab === nextTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });

      if (focus) nextTab.focus({ preventScroll: true });
      nextTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));

      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== index) {
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        }
      });
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll(selector).forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
